import React from "react";
import { withApollo } from "react-apollo";
import SimpleReactValidator from "simple-react-validator";

import { updateSubcategory } from "../../../services/graphql/queries/category-management";

import InputComponent from "../../Common/form-component/InputComponent";
import TextAreComponent from "../../Common/form-component/TextAreComponent";
import DisplayErrors from "../../Common/DisplayErrors";

import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg, successMsg } from "../../../miscellaneous/react-toastify";

import BreadCrumb from "./SubCategoryBreadCrumb"

class SubcategoryAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: [],
      subcategoryDetail:{
        name:"",
        description:"",
      },
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      element: message => <div style={{ color: "red" }}>{message}</div>
    });
    this.handleInput = this.handleInput.bind(this);
    this.onCreateSubcategory = this.onCreateSubcategory.bind(this);
    this.onBreadCrumbClick = this.onBreadCrumbClick.bind(this);
  }

  handleInput(e) {
    let value = e.target.value;
    let name = e.target.name;
    this.setState(prevState => {
      return {
        subcategoryDetail: {
          ...prevState.subcategoryDetail,
          [name]: value
        }
      };
    });
  }

  onBreadCrumbClick(data, index){
    this.props.onRemoveBreadCrumb(data, index)
  }

  onCreateSubcategory(e) {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.state.subcategoryDetail.id = this.props.selectedRecord.id;
      this.state.subcategoryDetail.status = this.props.selectedRecord.status;
      this.props.client
        .mutate({
          mutation: updateSubcategory,
          variables: this.state.subcategoryDetail,
          fetchPolicy: "no-cache"
        })
        .then(result => {
          successMsg("Updated successfully");
          this.props.toggleMode(true);
        })
        .catch(error => {
          console.log("~~~error: ", error);
          let message = errorMessage(error);
          errorMsg(message[0]);
          this.setState({ loading: false, errors: [errorMessage(error)] });
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
    }
  }
  componentDidMount(){
    const {
      name,
      description
    } = this.props.selectedRecord;
    let subcategoryDetail={
      name: name,
      description: description,
    }
    this.setState({ subcategoryDetail: subcategoryDetail })
  }

  render() {
    const {
      errors,
      subcategoryDetail,
    } = this.state;
    const { category, breadCrumbArr } = this.props;
    return (
      <>
        <div id="addDiv">
          <div className="row align-items-center">
            <div className="col-md-10">
              <h1 className="heading m-b-0">Edit Folder</h1>
              <div
                className="row"
                style={{
                  display: errors.length === 0 ? "none" : "block"
                }}
              >
                <div className="col-md-6">
                  <div className="alert alert-success" role="alert">
                    <div className="row">
                      <span className="danger-link">
                        <DisplayErrors errors={errors} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2 text-right">
              <a
                href="#"
                onClick={this.props.toggleMode}

                className="link-click "
              >
                <svg
                  x="0px"
                  y="0px"
                  width="16px"
                  height="16px"
                  viewBox="0 0 16 16"
                  enableBackground="new 0 0 16 16"
                  xmlSpace="preserve"
                >
                  <g>
                    <line
                      fill="none"
                      stroke="#69951a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      x1="3.25"
                      y1="3.25"
                      x2="12.75"
                      y2="12.75"
                    />
                    <line
                      fill="none"
                      stroke="#69951a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit={10}
                      x1="12.75"
                      y1="3.25"
                      x2="3.25"
                      y2="12.75"
                    />
                  </g>
                </svg>
                Close
              </a>
            </div>
          </div>
          <BreadCrumb data={breadCrumbArr} onBreadCrumbClick={this.onBreadCrumbClick}/>
          <form onSubmit={this.onCreateSubcategory}>
          <div className="row mt-3">
            <div className="col-md-12 col-lg-12">
              <div className="row">
                <div className="col-md-12 col-lg-4">
                  <InputComponent
                    required
                    type="text"
                    title="Name"
                    name="name"
                    label="Name"
                    value={subcategoryDetail.name}
                    placeholder="Enter Name"
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
                <div className="col-md-12 col-lg-8">
                  <TextAreComponent
                    required
                    title="Description"
                    name="description"
                    label="Description"
                    value={subcategoryDetail.description}
                    placeholder="Enter Description"
                    handleChange={this.handleInput}
                    validator={this.validator}
                    validation="required"
                  />
                </div>
              </div>
              <div className="col-md-12 col-lg-10">
                <div className="row">
                  <div className="col-md-12 ">
                    <button
                      type="submit"
                      className="btn btn-danger"
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-light m-l-50"
                      onClick={() => {
                        const {
                          name,
                          description
                        } = this.props.selectedRecord;
                        let subcategoryDetail={
                          name: name,
                          description: description,
                        }
                        this.setState({ subcategoryDetail: subcategoryDetail })
                        }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </form>
        </div>
      </>
    );
  }
}

export default withApollo(SubcategoryAdd);